<form [formGroup]="updateForm">
  <!-- Vorname -->
  <div class="category-separator">
    <p-fieldset>
      <ng-template pTemplate="header">
        <span><i class="pi pi-user"></i>&nbsp;&nbsp;Name</span>
      </ng-template>
      <div class="forms-element">
        <p-floatLabel>
          <input
            id="firstname"
            type="text"
            pInputText
            formControlName="firstname"
            placeholder="Max"
          />
          <label for="firstname">Vorname*</label>
        </p-floatLabel>
      </div>
      <!-- Nachname -->
      <div class="forms-element">
        <p-floatLabel>
          <input
            id="lastname"
            type="text"
            pInputText
            formControlName="lastname"
            placeholder="Mustermann"
          />
          <label for="lastname">Nachname*</label>
        </p-floatLabel>
      </div>
    </p-fieldset>
  </div>
  <div class="category-separator">
    <p-fieldset>
      <ng-template pTemplate="header">
        <span><i class="pi pi-phone"></i>&nbsp;&nbsp;Kontaktdaten</span>
      </ng-template>
      <!-- E-Mail -->
      <div class="forms-element">
        <p-floatLabel>
          <input
            id="email"
            type="text"
            pInputText
            formControlName="email"
            placeholder="Max.Mustermann@example.org"
          />
          <label for="email">E-Mail*</label>
        </p-floatLabel>
      </div>
      <!-- Telefonnummer -->
      <div class="forms-element">
        <p-floatLabel>
          <input
            id="phone"
            type="text"
            pInputText
            formControlName="phone"
            placeholder="+49177012345"
          />
          <label for="phone">Telefonnummer</label>
        </p-floatLabel>
      </div>
    </p-fieldset>
  </div>
  <div class="category-separator">
    <p-fieldset>
      <ng-template pTemplate="header">
        <span><i class="pi pi-home"></i>&nbsp;&nbsp;Addresse</span>
      </ng-template>
      <!-- Straße -->
      <div class="forms-element">
        <p-floatLabel>
          <input
            id="street"
            type="text"
            pInputText
            formControlName="street"
            placeholder="Musterstraße 123"
          />
          <label for="street">Straße</label>
        </p-floatLabel>
      </div>
      <!-- Postleitzahl -->
      <div class="forms-element">
        <p-floatLabel>
          <input
            id="postal"
            type="text"
            pInputText
            formControlName="postal"
            placeholder="01234"
          />
          <label for="postal">Postleitzahl</label>
        </p-floatLabel>
      </div>
      <!-- Stadt -->
      <div class="forms-element">
        <p-floatLabel>
          <input
            id="city"
            type="text"
            pInputText
            formControlName="city"
            placeholder="Musterstadt"
          />
          <label for="city">Stadt</label>
        </p-floatLabel>
      </div>
    </p-fieldset>
  </div>
  <!-- Checkbox Opt In E-Mails -->
  <div class="forms-element-center">
    <p-checkbox [binary]="true" formControlName="checkbox" id="checkbox" />
    <label for="checkbox"> Ich möchte E-Mails von dem System erhalten </label>
  </div>

  <div class="button-row">
    <p-button
      label="Speichern"
      icon="pi pi-save"
      [loading]="saving"
      [disabled]="saving"
      (onClick)="submit()"
      severity="success"
    />
  </div>
</form>
